import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"

export function sendSMSMessage(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/verify/send_phone_code`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function sendSEmailMessage(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/verify/send_mail_code`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function googleCodeStatus(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/security/google/status`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function bindGoogleCode(params) {
    return new Promise((resolve, reject) => {
        postJson(`${url_domain()}${url_pre()}/security/google/bind`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function unbindGoogleCode(params) {
    return new Promise((resolve, reject) => {
        postJson(`${url_domain()}${url_pre()}/security/google/unbind`, params)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function createGoogleCode(params) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/security/google/create`, params)
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}